import TileSubscribeButton from './TileSubscribeButton';

export default TileSubscribeButton;
